export default function Logo() {
  return <h1>🛩️ Far-Far Away 🧳</h1>;
}
